/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    geturls(url){
           let reg = /(https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
           if (!reg.test(url)) {
                     console.log(process.env.API_ROOT+url)
                   return process.env.API_ROOT+url
            }else{
                return url
            }
        },
    get(url,params){
        const config = {
            method: 'get',
            url:this.geturls(url)
        }
        if(params) config.params = params

        return request(config)
    },
    post(url,params){
        const config = {
            method: 'post',
            url:this.geturls(url)
            }
        if(params) config.data = params
        return request(config)
    },
    put(url,params){
        const config = {
            method: 'put',
            url:this.geturls(url)
        }
        if(params) config.params = params
        return request(config)
    },
    delete(url,params){
        const config = {
            method: 'delete',
            url:this.geturls(url)
        }
        if(params) config.params = params
        return request(config)
    }
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/utils/http.js